import React from 'react';

export const StickyNoteSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0312 2.09844V10.4719L10.4719 15.0312H2.1125C1.81294 15.0311 1.52569 14.912 1.31387 14.7002C1.10205 14.4884 0.982977 14.2011 0.982811 13.9016V2.09844C0.982749 1.95007 1.01193 1.80314 1.06868 1.66605C1.12543 1.52896 1.20864 1.4044 1.31355 1.29949C1.41847 1.19458 1.54303 1.11137 1.68011 1.05462C1.8172 0.997867 1.96413 0.968688 2.1125 0.96875H13.9016C14.0499 0.968688 14.1969 0.997867 14.3339 1.05462C14.471 1.11137 14.5956 1.19458 14.7005 1.29949C14.8054 1.4044 14.8886 1.52896 14.9454 1.66605C15.0021 1.80314 15.0313 1.95007 15.0312 2.09844V2.09844Z"
      fill="#F99746"
    />
    <path
      d="M10.4725 15.0313V11.6018C10.4725 11.4535 10.5017 11.3066 10.5585 11.1696C10.6152 11.0325 10.6984 10.908 10.8033 10.8031C10.9082 10.6983 11.0327 10.6151 11.1698 10.5583C11.3068 10.5016 11.4537 10.4724 11.602 10.4724H15.0312L10.4725 15.0313Z"
      fill="#DF7014"
    />
  </svg>
);

export default StickyNoteSvg;
